import Swal from 'sweetalert2';
import config from '@/config.js';
import store from '../store/index';

export function handleSocketMessage(event, state) {
  const data = JSON.parse(event.data);
  methods[data.action](data, state);
}

export function handleSocketError(error, state) {
  console.error('Erro no Websocket:', error);
}

export const methods = {
  openProc: (data, state) => {
    state.openedProcesses = data.data;
  },
  closeProc: (data, state) => {
    state.openedProcesses = data.data;
  },
  reqProc: (data, state) => {
    const reqData = data.data[Object.keys(data.data)[0]];

    Swal.fire({
      title: 'Solicitação de acesso ao Processo',
      html: `<p>O usuário ${reqData.name} está solicitando acesso a este processo.</p>`,
      type: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Liberar',
      showCancelButton: true,
      cancelButtonText: 'Não liberar',
    }).then((result) => {
      if (result.value) {
        state.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.CLOSE_PROC,
            data: {
              [Object.keys(data.data)[0]]: store.state.credentials.data.person.name,
            },
          }),
        );

        state.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.ACCEPT_PROC,
            data: {
              [Object.keys(data.data)[0]]: reqData,
            },
          }),
        );

        store.commit('ProcessStore/HIDE_PROCESS');
      } else {
        state.socket.send(
          JSON.stringify({
            action: config.env.WEBSOCKET.actions.REJECT_PROC,
            data: {
              [Object.keys(data.data)[0]]: reqData,
            },
          }),
        );
      }
    });
  },
  accProc: (data, state) => {
    Swal.fire({
      title: 'Solicitação de acesso ao Processo',
      html: '<p>O processo foi liberado.</p>',
      type: 'success',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
    });
  },
  rejProc: (data, state) => {
    Swal.fire({
      title: 'Solicitação de acesso ao Processo',
      html: '<p>O usuário ainda está editando o processo e precisa de mais tempo.</p>',
      type: 'error',
      showConfirmButton: true,
      confirmButtonText: 'Ok',
    });
  },
  updProc: (data, state) => {
	if ( Object.keys(data.data).length === 0 ) {
		return;	
	}
    const id = Object.keys(data.data)[0];
    const key = Object.keys(data.data[id])[0];
    const value = data.data[id][key];

    if (state.activeProcess && state.activeProcess.id == id) {
      state.activeProcess = {
        ...state.activeProcess,
        [key]: value,
      };
    }

    state.processes = state.processes.map((proc) => {
      if (proc.id == id) {
        return {
          ...proc,
          [key]: value,
        };
      }
      return proc;
    });
  },
};
